import React, { Component } from "react";
import { Breadcrumb } from "react-bootstrap";
import { connect } from "react-redux";
import Moment from "react-moment";
import Spinner from "react-bootstrap/Spinner";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";

class approvedView extends Component {
  constructor(props) {
    super(props);
    let encryptedId = this.props.location.search;
    var CryptoJS = require("crypto-js");
    var bytes = CryptoJS.AES.decrypt(
      encryptedId.replace("?p=", ""),
      process.env.REACT_APP_ENCRYPT_PASSWORD
    );
    var Referenceno = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    this.state = {
      file: null,
      downloadData: undefined,
      isFunctionCalled: false,
      isModalOpen: false,
      referenceNo: Referenceno,
      loading: "",
      requesterId: 0,
      isApproverDownload: false,
      approverComments: "",
      typeOfExit: 0,
      dateJoined: "",
      lastDayofService: "",
      phoneNumber: "",
      address: "",
      actionCategory: "",
      companycode: "",
      companyName: "",
      divisionName: "",
      divisioncode: "",
      actionType: 0,
      employeeId: "",
      employeeName: "",
      eDocType: "",
      startDate: "",
      endDate: "",
      positionId: "",
      salaryGrade: "",
      workingGroup: "",
      additionalInformation: "",
      description: "",
      userId: "",
      section: "",
      division: "",
      department: "",
      designation: "",
      requesterName: "",
      getApproverListArray: [],
      AttachmentslistArray: [],
      referenceLinkList: [
        {
          reflink: "",
          remarks: "",
        },
      ],
      attachmentList: [
        {
          referenceNo: "",
          filename: "",
          filetype: "",
          remarks: "",
          userId: 0,
        },
      ],
    };
  }

  openModal = () => {
    this.setState({ isModalOpen: true });
  };

  closeModal = () => {
    this.setState({ isModalOpen: false, isApproverDownload: false });
  };

  componentDidMount() {
    this.setState({ loading: "Yes" });
    this.props.dispatch({ type: "headerTitle", value: "Approved : View" });
    this.geteDocRequest();
    this.getApproverList();
    this.getApproverAttachement();
  }

  geteDocRequest = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/eDocDetails?ReferenceNo=${this.state.referenceNo}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            if (data.resultObject) {
              this.setState({
                referenceNo: data.resultObject.referenceNo,
                requesterId: data.resultObject.requesterId,
                typeOfExit: data.resultObject.typeOfExitName,
                dateJoined: data.resultObject.dateJoined,
                lastDayofService: data.resultObject.lastDayofService,
                phoneNumber: data.resultObject.phoneNumber,
                address: data.resultObject.address,
                actionCategory: data.resultObject.actionCategory,
                companycode: data.resultObject.companycode,
                companyName: data.resultObject.companyName,
                divisionName: data.resultObject.divisionName,
                divisioncode: data.resultObject.divisioncode,
                actionType: data.resultObject.actionTypeName,
                employeeId: data.resultObject.employeeId,
                eDocType: data.resultObject.eDocType,
                employeeName: data.resultObject.employeeName,
                startDate: data.resultObject.startDate,
                endDate: data.resultObject.endDate,
                positionId: data.resultObject.positionId,
                salaryGrade: data.resultObject.salaryGrade,
                workingGroup: data.resultObject.workingGroup,
                additionalInformation: data.resultObject.additionalInformation,
                description: data.resultObject.description,
                userId: data.resultObject.userId,
                referenceLinkList: data.resultObject.referenceLinkList,
                attachmentList: data.resultObject.attachmentList,
                requesterName:
                  data.resultObject.requesterId +
                  " - " +
                  data.resultObject.requesterName,
                section: data.resultObject.section,
                department: data.resultObject.department,
                division: data.resultObject.division,
                designation: data.resultObject.designation,
                loading: "",
                approverComments: data.resultObject.approverComments,
              });
            }
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  handleFileDownload = async (url) => {
    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();
      const fileUrl = URL.createObjectURL(blob);
      this.setState({ file: fileUrl });
      this.openModal();
      return null;
    } catch (error) {
      console.error("Error downloading file:", error.message);
    }
  };

  downloadFile = (data, type, isApprover) => {
    try {
      // if (!data?.filePath && !data?.fileRecord) {
      //   toast.info("The specified file or path not found", {
      //     position: toast.POSITION.TOP_CENTER,
      //     autoClose: 2000,
      //   });
      //   return;
      // }

      isApprover && type && this.setState({ isApproverDownload: true });
      const fileExtension = data.filename.split(".").pop().toLowerCase();
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          (data?.filePath
            ? `/api/Attachment/DownloadFromAzure?FilePath=${data?.filePath}`
            : `/api/Attachment/${
                isApprover || this.state.isApproverDownload
                  ? "DownloadApproverFile"
                  : "DownloadFile"
              }?SequenceNo=${data?.sequenceNo}`),
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            if (type === "view") {
              if (
                [
                  "html",
                  "htm",
                  "pdf",
                  "txt",
                  "jpg",
                  "jpeg",
                  "png",
                  "gif",
                  "bmp",
                  "mp3",
                  "mp4",
                ].includes(fileExtension)
              ) {
                this.handleFileDownload(response.url);
                this.setState({ downloadData: data });
                return null;
              } else {
                toast.info("This file can only be downloaded", {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                });
                window.open(response.url, "_blank");
              }
            } else {
              window.open(response.url, "_blank");
            }
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  editFloatingIcon = () => {
    var CryptoJS = require("crypto-js");
    window.location =
      process.env.REACT_APP_ENV +
      "/approved/edit?p=" +
      encodeURI(
        CryptoJS.AES.encrypt(
          JSON.stringify(this.state.referenceNo),
          process.env.REACT_APP_ENCRYPT_PASSWORD
        ).toString()
      );
  };

  getApproverList = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/GetApprovers?ReferenceNo=${this.state.referenceNo}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({ getApproverListArray: data.resultObject });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  getApproverAttachement = () => {
    try {
      fetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/eDoc/GetApproverAttachments?ReferenceNo=${this.state.referenceNo}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.props.getToken,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            this.props.dispatch({ type: "Referenceno", value: "" });
            this.props.dispatch({ type: "UserId", value: "" });
            this.props.dispatch({ type: "profile", value: "" });
            this.props.dispatch({ type: "headerTitle", value: "" });
            this.props.dispatch({ type: "Token", value: "" });
            this.props.dispatch({ type: "userType", value: "" });
            this.props.dispatch({ type: "userName", value: "" });
          }
        })
        .then((data) => {
          if (data) {
            this.setState({
              AttachmentslistArray: data.resultObject,
            });
          }
        })
        .catch((error) => {
          this.props.dispatch({ type: "Referenceno", value: "" });
          this.props.dispatch({ type: "UserId", value: "" });
          this.props.dispatch({ type: "profile", value: "" });
          this.props.dispatch({ type: "headerTitle", value: "" });
          this.props.dispatch({ type: "Token", value: "" });
          this.props.dispatch({ type: "userType", value: "" });
          this.props.dispatch({ type: "userName", value: "" });
        });
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    if (this.state.loading) {
      return (
        <>
          <Breadcrumb>
            <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
              Dashboard
            </Breadcrumb.Item>
            <Breadcrumb.Item
              href={process.env.REACT_APP_ENV + "/approved/list"}>
              Approved : View
            </Breadcrumb.Item>
            <Breadcrumb.Item active>View</Breadcrumb.Item>
          </Breadcrumb>
          <div className="content-area">
            <section>
              <div style={{ margin: "auto", width: "0%" }}>
                <Spinner animation="border" variant="primary" />
              </div>
            </section>
          </div>
        </>
      );
    } else {
      return (
        <>
          <Breadcrumb>
            <Breadcrumb.Item href={process.env.REACT_APP_ENV + "/dashboard"}>
              Dashboard
            </Breadcrumb.Item>
            <Breadcrumb.Item
              href={process.env.REACT_APP_ENV + "/approved/list"}>
              Approved : View
            </Breadcrumb.Item>
            <Breadcrumb.Item active>View</Breadcrumb.Item>
          </Breadcrumb>
          <div className="content-area">
            <section>
              <div className="form-group mb-2">
                <div className="approved-status">
                  <div className="">
                    <span className="mytask-approved-text">
                      Reference No.{" "}
                      <span className="d-none d-sm-inline"> :</span>
                    </span>{" "}
                    <span className="mytask-reference-text ">
                      {this.state.referenceNo}
                    </span>
                  </div>
                  <div className="">
                    <span className="mytask-approved-text">Status</span>{" "}
                    <div className="badge badge-mytask-approved">Approved</div>
                  </div>
                </div>
              </div>
            </section>
            <section className="view-taskpending-section">
              <h2 className="form-heading">Requester Information</h2>
              <div className="form-group row mb-0">
                <label
                  for=""
                  className="col-sm-2 requester-info  col-form-label">
                  {" "}
                  Staff No / Name{" "}
                </label>
                <div className="col-sm-4">
                  <div className="input-group mb-2 mr-sm-2">
                    <p className="m-0 py-2">
                      {" "}
                      <>
                        {" "}
                        <span className="d-none d-sm-inline mytask-reference-text">
                          {" "}
                          :{" "}
                        </span>{" "}
                        <span className="mytask-reference-text">
                          {this.state.requesterName}
                        </span>{" "}
                      </>{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="form-group row mb-0">
                <label
                  for=""
                  className="col-sm-2 requester-info col-form-label">
                  {" "}
                  Section
                </label>
                <div className="col-sm-4">
                  <div className="input-group mb-2 mr-sm-2">
                    <p className="m-0 py-2">
                      {" "}
                      <>
                        {" "}
                        <span className="d-none d-sm-inline mytask-reference-text">
                          {" "}
                          :{" "}
                        </span>{" "}
                        <span className="mytask-reference-text">
                          {this.state.section}
                        </span>{" "}
                      </>{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="form-group row mb-0">
                <label
                  for=""
                  className="col-sm-2 requester-info col-form-label">
                  {" "}
                  Department{" "}
                </label>
                <div className="col-sm-4">
                  <div className="input-group mb-2 mr-sm-2">
                    <p className="m-0 py-2">
                      {" "}
                      <>
                        {" "}
                        <span className="d-none d-sm-inline mytask-reference-text">
                          {" "}
                          :{" "}
                        </span>{" "}
                        <span className="mytask-reference-text">
                          {this.state.department}
                        </span>{" "}
                      </>{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="form-group row mb-0">
                <label
                  for=""
                  className="col-sm-2 requester-info col-form-label">
                  {" "}
                  Division{" "}
                </label>
                <div className="col-sm-4">
                  <div className="input-group mb-2 mr-sm-2">
                    <p className="m-0 py-2">
                      {" "}
                      <>
                        {" "}
                        <span className="d-none d-sm-inline mytask-reference-text">
                          {" "}
                          :{" "}
                        </span>{" "}
                        <span className="mytask-reference-text">
                          {this.state.division}
                        </span>{" "}
                      </>{" "}
                    </p>
                  </div>
                </div>
              </div>
              <div className="form-group row mb-0">
                <label
                  for=""
                  className="col-sm-2 requester-info col-form-label">
                  {" "}
                  Designation{" "}
                </label>
                <div className="col-sm-4">
                  <div className="input-group mb-2 mr-sm-2">
                    <p className="m-0 py-2">
                      {" "}
                      <>
                        {" "}
                        <span className="d-none d-sm-inline mytask-reference-text">
                          {" "}
                          :{" "}
                        </span>{" "}
                        <span className="mytask-reference-text">
                          {this.state.designation}
                        </span>{" "}
                      </>{" "}
                    </p>
                  </div>
                </div>
              </div>
            </section>

            <section className="view-taskpending-section">
              <h2 className="form-heading"> Requisition Details</h2>
              {this.state.eDocType?.includes("Employee Clearance") && (
                <div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      eDoc Type{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            <span className="mytask-reference-text">
                              {this.state.eDocType}
                            </span>{" "}
                          </>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      Type of Exit{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            <span className="mytask-reference-text">
                              {this.state.typeOfExit}
                            </span>{" "}
                          </>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      Date of Joined{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            <span className="mytask-reference-text">
                              {this.state.dateJoined && (
                                <Moment format="DD-MM-YYYY">
                                  {this.state.dateJoined}
                                </Moment>
                              )}
                            </span>{" "}
                          </>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      Last Day of Service{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              :{" "}
                            </span>
                            <span className="mytask-reference-text">
                              <Moment format="DD-MM-YYYY">
                                {this.state.lastDayofService}
                              </Moment>
                            </span>
                          </>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      Phone Number{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            <span className="mytask-reference-text">
                              {this.state.phoneNumber}
                            </span>{" "}
                          </>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      Address{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            <span className="mytask-reference-text">
                              {this.state.address}
                            </span>{" "}
                          </>{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="form-group row mb-0">
                    <label
                      for=""
                      className="col-sm-2 requester-info col-form-label">
                      {" "}
                      Description{" "}
                    </label>
                    <div className="col-sm-10">
                      <div className="d-flex align-items-baseline">
                        <p className="">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            {/* <span className="mytask-reference-text">
                                {this.state.description}
                              </span>{" "} */}
                          </>{" "}
                        </p>
                        <p
                          className="mytask-reference-text"
                          style={{ marginLeft: 5, marginTop: 9 }}
                          dangerouslySetInnerHTML={{
                            __html: this.state.description,
                          }}></p>
                      </div>
                    </div>
                    {/* <div className="col-sm-10">
                      <div className="input-group mb-2 mr-sm-2">
                        <p className="m-0 py-2">
                          {" "}
                          <>
                            {" "}
                            <span className="d-none d-sm-inline mytask-reference-text">
                              {" "}
                              :{" "}
                            </span>{" "}
                            <span className="mytask-reference-text">
                              {this.state.description}
                            </span>{" "}
                          </>{" "}
                        </p>
                      </div>
                    </div> */}
                  </div>
                </div>
              )}
              {this.state.eDocType == "HRIS" &&
                this.state.actionCategory == "Single" && (
                  <div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        eDoc Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.eDocType}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Action Category{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.actionCategory}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Company Code
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.companyName}
                              </span>
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Division Code{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.divisionName}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        EmployeeId / Name{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.employeeName}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Position ID{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.positionId}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Salary Grade{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.salaryGrade}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Working Group{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.workingGroup}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Addtional Information{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.additionalInformation}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Start Date{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.startDate && (
                                  <Moment format="DD-MM-YYYY">
                                    {this.state.startDate}
                                  </Moment>
                                )}
                              </span>
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        End Date{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.endDate && (
                                  <Moment format="DD-MM-YYYY">
                                    {this.state.endDate}
                                  </Moment>
                                )}
                              </span>
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Description{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="d-flex align-items-baseline">
                          <p className="">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {/* <span className="mytask-reference-text">
                                {this.state.description}
                              </span>{" "} */}
                            </>{" "}
                          </p>
                          <p
                            className="mytask-reference-text"
                            style={{ marginLeft: 5, marginTop: 9 }}
                            dangerouslySetInnerHTML={{
                              __html: this.state.description,
                            }}></p>
                        </div>
                      </div>
                      {/* <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.description}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div> */}
                    </div>
                  </div>
                )}
              {this.state.eDocType == "HRIS" &&
                this.state.actionCategory == "Group" && (
                  <div>
                    <div className="form-group requester-info row mb-0">
                      <label for="" className="col-sm-2 col-form-label">
                        {" "}
                        eDoc Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.eDocType}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Action Category{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.actionCategory}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Action Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.actionType}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              {this.state.eDocType == "HRIS" &&
                this.state.actionCategory == "None" && (
                  <div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        eDoc Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.eDocType}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Action Category{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.actionCategory}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Action Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.actionType}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Others{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.additionalInformation}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              {this.state.eDocType != "HRIS" &&
                !this.state.eDocType?.includes("Employee Clearance") && (
                  <div>
                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        eDoc Type{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.eDocType}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row mb-0">
                      <label
                        for=""
                        className="col-sm-2 requester-info col-form-label">
                        {" "}
                        Description{" "}
                      </label>
                      <div className="col-sm-10">
                        <div className="d-flex align-items-baseline">
                          <p className="">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              {/* <span className="mytask-reference-text">
                                {this.state.description}
                              </span>{" "} */}
                            </>{" "}
                          </p>
                          <p
                            className="mytask-reference-text"
                            style={{ marginLeft: 5, marginTop: 9 }}
                            dangerouslySetInnerHTML={{
                              __html: this.state.description,
                            }}></p>
                        </div>
                      </div>
                      {/* <div className="col-sm-10">
                        <div className="input-group mb-2 mr-sm-2">
                          <p className="m-0 py-2">
                            {" "}
                            <>
                              {" "}
                              <span className="d-none d-sm-inline mytask-reference-text">
                                {" "}
                                :{" "}
                              </span>{" "}
                              <span className="mytask-reference-text">
                                {this.state.description}
                              </span>{" "}
                            </>{" "}
                          </p>
                        </div>
                      </div> */}
                    </div>
                  </div>
                )}
            </section>
            <section>
              <h2 className="form-heading"> Attachments </h2>
              <table className="table table-bordered overflow-auto-x">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col"> File Name </th>
                    {/* <th scope="col"> File Type </th> */}
                    <th scope="col"> Remarks </th>
                    <th scope="col"> Action </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.attachmentList?.map((data, index) => (
                    <>
                      <tr>
                        <td>{index + 1}</td>
                        <td>{data.filename}</td>
                        {/* <td>{data.filetype}</td> */}
                        <td>{data.remarks}</td>
                        <td>
                          <a
                            onClick={() => this.downloadFile(data, "view")}
                            target="_blank">
                            <img
                              className="action-right-space mouse-pointer"
                              src={
                                process.env.REACT_APP_ENV +
                                "/assets/images/icons/action/awesome-eye.svg"
                              }
                              alt="View"
                              data-tip="View"
                            />
                          </a>
                        </td>
                      </tr>
                      <Modal
                        show={this.state.isModalOpen}
                        onHide={this.closeModal}
                        size="xl">
                        <Modal.Header closeButton>
                          <Modal.Title>Attachment</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          {" "}
                          <div>
                            {this.state.file ? (
                              <iframe
                                src={this.state.file}
                                title="File Viewer"
                                width="100%"
                                height="500px"></iframe>
                            ) : (
                              <p>Loading...</p>
                            )}
                          </div>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="primary"
                            onClick={() =>
                              this.downloadFile(this.state.downloadData)
                            }>
                            Download
                          </Button>
                          <Button variant="secondary" onClick={this.closeModal}>
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                    </>
                  ))}
                </tbody>
              </table>
              {(() => {
                if (this.state.attachmentList?.length <= 0) {
                  return (
                    <div>
                      <p className="text-center">No record found.</p>
                    </div>
                  );
                }
              })()}

              <h2 className="form-heading"> Approver Attachments </h2>
              <table className="table table-bordered overflow-auto-x">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col"> File Name </th>
                    {/* <th scope="col"> File Type </th> */}
                    <th scope="col"> Remarks </th>
                    <th scope="col"> Action </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.AttachmentslistArray?.map((data, index) => (
                    <>
                      <tr>
                        <td>{index + 1}</td>
                        <td>{data.filename}</td>
                        {/* <td>{data.filetype}</td> */}
                        <td>{data.remarks}</td>
                        <td>
                          <a
                            onClick={() =>
                              this.downloadFile(data, "view", "isApprover")
                            }
                            target="_blank">
                            <img
                              className="action-right-space mouse-pointer"
                              src={
                                process.env.REACT_APP_ENV +
                                "/assets/images/icons/action/awesome-eye.svg"
                              }
                              alt="View"
                              data-tip="View"
                            />
                          </a>
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
              {(() => {
                if (this.state.AttachmentslistArray?.length <= 0) {
                  return (
                    <div>
                      <p className="text-center">No record found.</p>
                    </div>
                  );
                }
              })()}

              <h2 className="form-heading"> References </h2>
              <table className="table table-bordered ">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col"> Reference Link </th>
                    <th scope="col"> Remarks </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.referenceLinkList?.map((data, index) => (
                    <tr>
                      <td>{data.rowno}</td>
                      <td>
                        <u
                          style={{
                            color: "blue",
                            cursor: "pointer",
                          }}>
                          <a
                            onClick={() =>
                              data.reflink.includes("https")
                                ? window.open(data.reflink, "_blank")
                                : window.open(
                                    `https://${data.reflink}`,
                                    "_blank"
                                  )
                            }>
                            {data.reflink}
                          </a>
                        </u>
                      </td>
                      <td>{data.remarks}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {(() => {
                if (this.state.referenceLinkList?.length <= 0) {
                  return (
                    <div>
                      <p className="text-center">No record found.</p>
                    </div>
                  );
                }
              })()}
              {/* <h2 className="form-heading"> Comments </h2>
              <table className="table table-bordered ">
                <div style={{ margin: "1rem" }}>
                  <tbody>{this.state.approverComments}</tbody>
                </div>
              </table> */}
            </section>
            <section>
              <h2 className="form-heading"> Approver List </h2>
              <div className="table-responsive custom-table-1">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col"> Sequence No </th>
                      <th scope="col"> Approver </th>
                      <th scope="col"> Section </th>
                      <th scope="col"> Comments </th>
                      <th scope="col"> Status </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state?.getApproverListArray?.map((loopdata) => (
                      <tr>
                        <td> {loopdata.sequenceno} </td>
                        <td>
                          {" "}
                          {loopdata.oriapproverid} / {loopdata.oriapprovername}{" "}
                        </td>
                        <td> {loopdata.section} </td>
                        <td> {loopdata.comments} </td>
                        <td>
                          {" "}
                          <div className="badge badge-approved">
                            {loopdata.wfstatus}
                          </div>{" "}
                        </td>
                        {/* {(() => {
                        if (loopdata.isEdit == 1) {
                          return (
                            <td>
                              <div className="action-icons">
                                <i
                                  className="fa fa-pencil-square-o text-muted"
                                  aria-hidden="true"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Edit"
                                  onClick={() =>
                                    this.editApprover(loopdata.Workflowid)
                                  }
                                ></i>
                              </div>
                            </td>
                          )
                        } else {
                          return <td></td>
                        }
                      })()}
                      <td> {loopdata.comments} </td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
          </div>
        </>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    headerTitle: state.headerTitle,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};

export default connect(mapStateToProps)(approvedView);
